import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import oWnApi from 'utils/WnApi';
import { currentUserLookupIdSelector } from 'redux/selectors';
import useCodeTablesSection from 'utils/hooks/useCodeTablesSection';
import { fetchUserAttributes } from 'aws-amplify/auth';

const usePostFeedback = () => {
  const aCodes = useCodeTablesSection('CONSTITUENTNOTETYPE');
  const sFeedbackNoteTypeCodeId =
    aCodes.find((item) => item.DESCRIPTION === 'Wake Network: User Feedback')
      ?.ID || null;
  const sLookupId = useSelector(currentUserLookupIdSelector);

  const postFeedback = useCallback(
    async (feedback, sReCaptchaToken = '') => {
      // Build the name of the current page
      // get the current path without the leading slash
      let page = window.location.pathname.substring(1);
      // change 'main' into 'profile' to make it more human-friendly
      page = page === 'main' ? 'profile' : page;
      // capitalize the page name
      page = page.charAt(0).toUpperCase() + page.substring(1);

      let oResponse;
      if (sLookupId) {
        // Record feedback from authenticated users as a note.
        const sRequestUrl = `constituents/${sLookupId}/add_note`;
        oResponse = await oWnApi.post(sRequestUrl, {
          TYPE: 'Note',
          data: {
            TITLE: `${page} Page Feedback`,
            TEXTNOTE: `${page} page: ${feedback}`,
            NOTETYPECODEID: sFeedbackNoteTypeCodeId,
          },
        });
      } else {
        // Record feedback from unauthenticated users via contact us.
        const oUserAttributes = await fetchUserAttributes();
        const oRequestPayload = {
          firstname: oUserAttributes.given_name || '',
          lastname: oUserAttributes.family_name || '',
          email: oUserAttributes.email || '',
          comments: `${page} Page Feedback: ${feedback}`,
          contactmethod: 'email',
          reCaptchaToken: sReCaptchaToken,
        };
        oResponse = await oWnApi.post('contact_us', oRequestPayload, false);
      }
      if (oResponse.status !== 200) {
        throw new Error(
          `Failed to submit feedback. ${oResponse.status}: ${oResponse.statusText}`
        );
      }
    },
    [sLookupId, sFeedbackNoteTypeCodeId]
  );

  return { postFeedback, bIsLoading: !sFeedbackNoteTypeCodeId };
};

export default usePostFeedback;
